import { Navigate, Route, Routes } from "react-router-dom";
import { AuthBootstrap } from "./auth/AuthBootstrap";
import { ProtectedRoute } from "./auth/ProtectedRoute";
import { AdminRoute } from "./auth/AdminRoute";
import { AppShell } from "./components/AppShell";
import { LoginPage } from "./pages/LoginPage";
import { DashboardPage } from "./pages/DashboardPage";
import { AdminPage } from "./pages/AdminPage";
import { useAuthStore } from "./auth/auth.store";

export default function App() {
  const ready = useAuthStore((s) => s.ready);
  return (
    <>
      <AuthBootstrap />
      {!ready ? (
        <div className="flex h-full w-full items-center justify-center text-subtext0">
          Inicjalizacja…
        </div>
      ) : (
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route
            element={
              <ProtectedRoute>
                <AppShell />
              </ProtectedRoute>
            }
          >
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route path="/dashboard" element={<DashboardPage />} />
            <Route
              path="/admin"
              element={
                <AdminRoute>
                  <AdminPage />
                </AdminRoute>
              }
            />
          </Route>
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      )}
    </>
  );
}
